import { NationalResourceEntityType } from "@eolas-medical/core";

const communityKeys = {
  all: ["nationalBodies"],
  bodies: (entityType: NationalResourceEntityType) => [...communityKeys.all, entityType],
};

export default communityKeys;
